import { render, staticRenderFns } from "./AutoSaveForm.vue?vue&type=template&id=1af4a418&scoped=true"
import script from "./AutoSaveForm.vue?vue&type=script&lang=js"
export * from "./AutoSaveForm.vue?vue&type=script&lang=js"
import style0 from "./AutoSaveForm.vue?vue&type=style&index=0&id=1af4a418&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Desktop/Trabajo/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af4a418",
  null
  
)

export default component.exports